module.exports = __webpack_public_path__ + "media/icons/medal-1489ac6b.png";